import {createFileRoute} from '@tanstack/react-router';

import ImagePage from '~components/common/ImagePage';
import {ModelProvider} from 'src/contexts/ModelProvider';

export const Route = createFileRoute('/simsearch/image')({
  component: SimsearchImagePage,
});

function SimsearchImagePage(): JSX.Element {
  return (
    <ModelProvider mode='archive-annotator'>
      <ImagePage />
    </ModelProvider>
  );
}
